/**
 * `AppFrame`'s development warning for a rail frame whose page did not lift
 * its column (1.6.0): said once per page, however many frames come and go.
 * Plain TypeScript (not the component's module script) so a test can reset
 * it; not exported from the package.
 */

let warned = false;

/** True the first time it is asked, false ever after (until a reset). */
export function claimRailWarning(): boolean {
  if (warned) return false;
  warned = true;
  return true;
}

/** Whether the warning has been said on this page. */
export function railWarningSaid(): boolean {
  return warned;
}

/** Test-only: the warning may be said again. */
export function resetRailWarning(): void {
  warned = false;
}
